var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1a681b49e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.5 128.863281 L 262.5 128.863281 L 262.5 245.863281 L 112.5 245.863281 Z M 112.5 128.863281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a681b49e5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40E0D0",
    d: "M 149.089844 187.828125 L 171.492188 187.828125 L 171.492188 246.132812 L 112.527344 246.132812 L 112.527344 196.984375 C 112.527344 172.9375 118.390625 155.710938 130.085938 145.269531 C 141.777344 134.824219 158.445312 129.359375 180.054688 128.863281 L 180.351562 152.515625 C 154.59375 155.214844 147.148438 166.480469 149.089844 187.828125 Z M 231.507812 187.828125 L 253.910156 187.828125 L 253.910156 246.132812 L 194.945312 246.132812 L 194.945312 196.984375 C 194.945312 172.9375 200.808594 155.710938 212.503906 145.269531 C 224.195312 134.824219 240.863281 129.359375 262.472656 128.863281 L 262.472656 152.746094 C 236.714844 155.414062 229.566406 166.480469 231.507812 187.828125 Z M 231.507812 187.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.435dbd4a072f845275172ba69ebc55e2.svg";
export { ForwardRef as ReactComponent };